import { Component, input, output } from '@angular/core';

@Component({
  selector: 'rid-dice-slot',
  imports: [],
  templateUrl: './rid-dice-slot.html',
})
export class RidDiceSlot {
  color = input.required<'PINK' | 'BLUE' | 'EMERALD'>();
  value = input<number | string | undefined>(undefined);
  togglable = input.required<boolean>();

  toggled = output<void>();
}
